import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import ProjectsTable from "../Projects/ProjectsTable";

const COPY = {
  title: "Manage Projects",
  subtitle: "You Can See & Edit Detail About Verified Projects",
  searchPlaceholder: "Search Here",
};

const ProjectsAdmin = () => {
  const { items, loading, searchValue, setSearchValue } =
    useAdminList("getProjects");

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <ProjectsTable driverData={items} />
    </AdminPage>
  );
};

export default ProjectsAdmin;
